<template>
	<div class="home-banner dp-f">
		<div class="home-banner-eagle">
			<div class="eagle-pic">
				<img :src="currentBanner" />
			</div>

			<div class="eagle-buy dp-f">
				<a class="but-now" href="javascript:;">
					<e-button
						class="buy-now-button"
						type="primary"
						@click="freeTrialClick"
						round
						>{{ getConstants('EAGLE_LANDING_COMMON_FREE') }}</e-button
					>
				</a>
				<a class="buy-detai" href="#app_sale">
					<e-button round>{{
						getConstants('EAGLE_LANDING_BANNER_BUYNOW')
					}}</e-button>
				</a>
			</div>
		</div>
		<div class="home-banner-display">
			<img src="../images/svg/home-banner-display.svg" alt />
		</div>
	</div>
</template>
<script>
import bannerEn from '../images/svg/home-banner-eagle-en.svg'
import bannerZh from '../images/svg/home-banner-eagle.svg'
import buyStore from '../buyStore'

export default {
	data() {
		return {}
	},
	methods: {
		jumpToBenift() {
			Location.href = '#app_benifits'
		},

		freeTrialClick() {
			if (!this.PageInfo.accountState) {
				location.href = `/d/signup?next=/s/tutorial/eagle?coupon_code=${
					buyStore.coupon.coupon_code
				}`
			} else {
				location.href = `/s/tutorial/eagle?coupon_code=${
					buyStore.coupon.coupon_code
				}`
			}
		},
	},
	computed: {
		currentBanner() {
			return this.getConstants('LOCAL_LANGUAGE') === 'en' ? bannerEn : bannerZh
		},
	},
}
</script>

<style lang="scss" scoped>
.home-banner {
	justify-content: center;
	flex-wrap: wrap;
	.home-banner-eagle {
		width: 500px;
		margin-top: 118px;
		margin-right: 16px;
		text-align: center;
		.eagle-pic {
			img {
				width: 500px;
				height: 250px;
			}
		}
	}
	.eagle-buy {
		margin-top: 40px;
		justify-content: flex-start;
		button {
			width: 120px;
			height: 40px;
		}
	}
	.buy-now-button {
		margin-right: 16px;
	}
	.home-banner-display {
		margin-top: 78px;
		text-align: center;
		img {
			width: 648px;
			height: 445px;
		}
	}
}
@media (max-width: 768px) and (min-width: 414px) {
	.home-banner {
		.home-banner-eagle {
			margin-right: 0;
			padding: 0 20px 0;
		}
	}
}

@media (max-width: 414px) {
	.home-banner {
		padding-top: 0;
		.home-banner-eagle {
			margin-top: 24px;
			margin-right: 0;
			padding: 0 20px 0;
			text-align: center;
			.eagle-pic {
				img {
					width: 288px;
					height: 144px;
				}
			}
		}
		.home-banner-display {
			margin-top: 40px;
			text-align: center;
			img {
				width: 288px;
				height: 198px;
			}
		}
		.eagle-buy {
			justify-content: center;
		}
	}
}

/* @media (max-width: 765px) {
	.home-banner {
		.home-banner-eagle {
			width: 250px;
			margin: 36px auto 0;
			padding-top: 145px;
			background: url('../images/home-banner-eagle.svg') 0 20px no-repeat;
			background-size: 50% 50%;
		}
		.home-banner-display {
			margin-top: 36px;
			text-align: center;
		}
	}
} */
</style>
